import { render, staticRenderFns } from "./ChecklistsChecklist.vue?vue&type=template&id=a635704a&scoped=true"
import script from "./ChecklistsChecklist.vue?vue&type=script&lang=js"
export * from "./ChecklistsChecklist.vue?vue&type=script&lang=js"
import style0 from "./ChecklistsChecklist.vue?vue&type=style&index=0&id=a635704a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a635704a",
  null
  
)

export default component.exports